// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"057706f3ea8df795","993":"db6df92a411a462f"}[chunkId] + ".css";
};